export enum EntityType {
  // Shared / Core
  USER = "USER",
  ROLE = "ROLE",
  BRANCH = "BRANCH",
  COMPANY = "COMPANY",
  SCHOOL = "SCHOOL",
  ADDRESS = "ADDRESS",
  PERMISSION = "PERMISSION",
  SETTINGS = "SETTINGS",
  AUDIT_LOG = "AUDIT_LOG",
  NOTIFICATION = "NOTIFICATION",
  LEDGER_ENTRY = "LEDGER_ENTRY",
  ITEM = "ITEM",
  CUSTOMER = "CUSTOMER",
  SHIFT = "SHIFT",
  EXPENSE_CATEGORY = "EXPENSE_CATEGORY",
  DOCUMENT_HEADER = "DOCUMENT_HEADER",
  CUSTOMER_USER = "CUSTOMER_USER",

  // Procurement & Inventory
  SUPPLIER = "SUPPLIER",
  SUPPLIER_CONTACT = "SUPPLIER_CONTACT",
  PURCHASE_ORDER = "PURCHASE_ORDER",
  PURCHASE_ORDER_ITEM = "PURCHASE_ORDER_ITEM",
  INVENTORY_ITEM = "INVENTORY_ITEM",
  SALE = "SALE",
  CUSTOMER_ORDER = "CUSTOMER_ORDER",
  QUOTATION = "QUOTATION",
  STOCK_LEVEL = "STOCK_LEVEL",
  INVENTORY_LOG = "INVENTORY_LOG",
  BRAND = "BRAND",
  CATEGORY = "CATEGORY",
  QUANTITY_UNIT = "QUANTITY_UNIT",
  PACKAGE_UNIT = "PACKAGE_UNIT",

  // Finance & Cashflow
  PAYMENT = "PAYMENT",
  ACCOUNT = "ACCOUNT",
  PAYMENT_METHOD = "PAYMENT_METHOD",
  COMPANY_CHARGE = "COMPANY_CHARGE",
  TAX_CODE = "TAX_CODE",
  EXPENSE = "EXPENSE",
  RECEIPT = "RECEIPT",
  INVOICE = "INVOICE",
  CREDIT_NOTE = "CREDIT_NOTE",
  DEBT = "DEBT",
  UNALLOCATED_PAYMENT = "UNALLOCATED_PAYMENT",
  CURRENCY = "CURRENCY",
  SEQUENCE = "SEQUENCE",

  // Communications
  COMMUNICATION_INTEGRATION = "COMMUNICATION_INTEGRATION",
  PAYMENT_INTEGRATION = "PAYMENT_INTEGRATION",
  SMS_OUTBOX = "SMS_OUTBOX",
  SMS_TEMPLATE = "SMS_TEMPLATE",
  WHATSAPP_MESSAGE = "WHATSAPP_MESSAGE",
  WHATSAPP_CONVERSATION = "WHATSAPP_CONVERSATION",
  ANNOUNCEMENT = "ANNOUNCEMENT",
}
